module.exports = __webpack_public_path__ + "assets/img/7dfc81fad98898f5c9b88591b452d430.svg";